var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.603,
    height: 24.489,
    viewBox: "0 0 20.603 24.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report",
    transform: "translate(-154 -29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17316",
    "data-name": "Path 17316",
    d: "M168.96,29H155.472A1.473,1.473,0,0,0,154,30.472V52.017a1.473,1.473,0,0,0,1.472,1.472h17.659a1.473,1.473,0,0,0,1.472-1.472V34.643Zm.345,2.01,3.288,3.288H169.6A.3.3,0,0,1,169.3,34Zm3.826,21.3H155.472a.3.3,0,0,1-.294-.294V30.471a.3.3,0,0,1,.294-.294h12.656V34a1.473,1.473,0,0,0,1.472,1.472h3.826V52.017a.3.3,0,0,1-.294.294Zm-9.124-15.071h-.589a7.064,7.064,0,1,0,7.064,7.064v-.589h-6.475Zm5.268,7.652a5.887,5.887,0,1,1-6.446-6.446v6.446Zm-4.091-9.418H164.6v7.652h7.652v-.589a7.072,7.072,0,0,0-7.064-7.064Zm.589,6.475V36.682a5.9,5.9,0,0,1,5.268,5.268Z",
    fill: "#bebfb6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.736fb1bef1f9fb58eb339dd22818fe2e.svg";
export { ForwardRef as ReactComponent };